var _path, _path2, _circle, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 125,
    viewBox: "0 0 181 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174.613 124C185.347 97.1844 182.1 67.2418 168.256 44.2452L23.3348 64.2955L162.215 35.3746C103.683 -37.5584 -10.2415 10.8172 0.740232 102.9L174.613 124Z",
    fill: "#6CBE46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M174.613 124C185.347 97.1844 182.1 67.2418 168.256 44.2452L23.3348 64.2955L162.215 35.3746C103.683 -37.5584 -10.2415 10.8172 0.740232 102.9L174.613 124Z",
    fill: "white",
    fillOpacity: 0.85
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 88.5,
    r: 36.5,
    fill: "#6CBE46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8809 73.0895C69 74.3266 69 78.0039 69 85.3583V88.9801C69 101.948 78.8909 108.241 85.0966 110.913C86.78 111.638 87.6217 112 90 112C92.3783 112 93.22 111.638 94.9034 110.913C101.109 108.241 111 101.948 111 88.9801V85.3583C111 78.0039 111 74.3266 110.119 73.0895C109.238 71.8524 105.731 70.6689 98.7152 68.3018L97.3786 67.8508C93.7217 66.6169 91.8932 66 90 66C88.1068 66 86.2783 66.6169 82.6214 67.8508L81.2848 68.3018C74.2694 70.6689 70.7617 71.8524 69.8809 73.0895ZM93.5 95.9C93.5 97.1703 92.4553 98.2 91.1667 98.2H88.8333C87.5447 98.2 86.5 97.1703 86.5 95.9V92.6769C84.4077 91.4839 83 89.254 83 86.7C83 82.8892 86.134 79.8 90 79.8C93.866 79.8 97 82.8892 97 86.7C97 89.254 95.5923 91.4839 93.5 92.6769V95.9Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.84e962bf989bb4acd54280b028238cfd.svg";
export { ForwardRef as ReactComponent };